var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class EngineApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'transactions';
    }
    getTransaction(query) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: query,
            });
        });
    }
    listTransactions(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/all`, params: query }, options));
        });
    }
    createTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data: params,
            });
        });
    }
    getBalanceByAccount(accountId_1) {
        return __awaiter(this, arguments, void 0, function* (accountId, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/balance/account/${accountId}` }, options));
        });
    }
    getBalanceByCustomer(customerId_1) {
        return __awaiter(this, arguments, void 0, function* (customerId, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/balance/customer/${customerId}` }, options));
        });
    }
    createBonusTransaction(customerId_1, amount_1) {
        return __awaiter(this, arguments, void 0, function* (customerId, amount, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/bonus`, data: {
                    customerId,
                    amount,
                } }, options));
        });
    }
}
//# sourceMappingURL=index.js.map